import React, { useState } from 'react';
import { useI18n } from './i18n';

// Slider for a decimal rating. Props: label, value (number, or null/'' = not scored), onChange(number | null),
// min, max, step, hint (optional help text behind the "?" button), nullable (default true: shows a "clear" button and
// "not scored" until the slider is moved), unit (optional suffix such as '/10').
// A value is only stored once the user touches the slider, so "not scored" stays distinguishable from the minimum.
function ScoreSlider({ label, value, onChange, min = 0, max = 10, step = 0.5, hint, nullable = true, unit = '' }) {
  const { t, formatNumber } = useI18n();
  const [showHint, setShowHint] = useState(false);
  const scored = value !== null && value !== undefined && value !== '';
  const current = scored ? Number(value) : (nullable ? min : 0);
  const decimals = step < 0.5 ? 2 : (step < 1 ? 1 : 0);

  return (
    <div className="pairing-slider score-slider">
      <label>
        <span className="pairing-label food">{label}</span>
        <span className="pairing-value">{scored ? `${formatNumber(current, decimals)}${unit}` : t('products.slider.not_scored')}</span>
        {hint && (
          <button type="button" className="info-btn" title={t('products.slider.hint')}
            onClick={(e) => { e.preventDefault(); setShowHint(!showHint); }}>?</button>
        )}
        {nullable && scored && (
          <button type="button" className="chip score-clear" onClick={() => onChange(null)}>{t('products.slider.clear')}</button>
        )}
      </label>
      <input type="range" min={min} max={max} step={step} value={current} className="range-food"
        onChange={(e) => onChange(parseFloat(e.target.value))} />
      {showHint && hint && <div className="info-box">{hint}</div>}
    </div>
  );
}

export default ScoreSlider;
